<template>
  <el-scrollbar always>
    <h1>Rentbutik Admin Dashboard.</h1>
    Home page.
  </el-scrollbar>
</template>

<script setup lang="ts"></script>
